(function autoCloseDetails() {
  document.addEventListener('click', function (event) {
    const detailsToClose = [...document.querySelectorAll('details[data-auto-close-details][open]')].filter(
      (element) => {
        const closingOn = window.innerWidth < 750 ? 'mobile' : 'desktop';
        return (
          element.getAttribute('data-auto-close-details')?.includes(closingOn) &&
          !(event.target instanceof Node && element.contains(event.target))
        );
      }
    );

    for (const detailsElement of detailsToClose) detailsElement.removeAttribute('open');
  });
})();

// UBISY / Radiant — only one facet panel open at a time
document.addEventListener(
  "click",
  (event) => {
    const summary = event.target.closest(".facets__summary");
    if (!summary) return;

    const panel = summary.closest("details.facets__panel");
    if (!panel) return;

    // Find the nearest filters wrapper (works in desktop + drawer)
    const wrapper = panel.closest(".facets__filters-wrapper, .facets__inputs");
    if (!wrapper) return;

    // Let the theme/browser toggle open first, then close others
    setTimeout(() => {
      if (!panel.open) return;

      wrapper.querySelectorAll("details.facets__panel[open]").forEach((el) => {
        if (el !== panel) el.removeAttribute("open");
      });
    }, 0);
  },
  true
);
// UBISY / Radiant — collapse facet panels on desktop load (keep active ones open)
document.addEventListener("DOMContentLoaded", () => {
  // Desktop only (matches your theme breakpoint)
  if (window.innerWidth < 750) return;

  document.querySelectorAll("details.facets__panel[open]").forEach((panel) => {
    // Keep open if it has active selections (checked inputs) or price filled
    const hasChecked = panel.querySelector('input[type="checkbox"]:checked, input[type="radio"]:checked');
    const hasPrice =
      panel.querySelector('input[name*="min"], input[name*="max"]') &&
      [...panel.querySelectorAll('input[name*="min"], input[name*="max"]')].some((i) => i.value && i.value !== "0");

    if (hasChecked || hasPrice) return;

    panel.removeAttribute("open");
  });
});